<template>
    <v-layout align-start>
        <v-flex>
            <v-data-table :headers="headers" :items="expedientes" :search="search" class="elevation-1">
                <template v-slot:top>
                    <v-toolbar color="white">
                        <v-toolbar-title>Expediente</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>

                        <v-text-field class="text-xs-center" v-model="search" append-icon="search" label="Búsqueda"
                            single-line hide-details></v-text-field>
                        <v-spacer></v-spacer>

                        <v-dialog v-model="dialog" max-width="600">
                            <template v-slot:activator="{ on }">
                                <v-btn color="primary" dark class="mb-2" v-on="on">Nuevo</v-btn>
                            </template>
                            <v-card>
                                <v-card-title>
                                    <span class="headline">{{ formTitle }}</span>
                                </v-card-title>
                                <v-card-text>
                                    <v-container>
                                        <v-row>

                                            <v-col cols="12" sm="12" md="12" class="py-0">
                                                <v-text-field v-model="expedientenombre"
                                                    label="Nombre Completo de la expediente" outlined></v-text-field>
                                            </v-col>

                                            <v-col cols="12" sm="9" md="9" class="py-0">
                                                <v-select v-model="carpetaid" :items="carpetaselect"
                                                    label="Nombre de la Carpeta" outlined
                                                    v-on:change="selectecarpetanombre()"></v-select>
                                            </v-col>

                                            <v-col cols="12" sm="3" md="3" class="py-0">
                                                <v-btn color="blue darken-1" text @click="agregar">Agregar</v-btn>

                                            </v-col>

                                            <v-list three-line>
                                                <template v-for="(item, index) in items">
                                                    <v-list-item>
                                                        <v-list-item-avatar>
                                                            <v-icon class="grey lighten-1" dark>
                                                                account_balance
                                                            </v-icon>
                                                        </v-list-item-avatar>

                                                        <v-list-item-title style="white-space: normal;">
                                                            {{ item.carpetanombre }}
                                                        </v-list-item-title>

                                                        <v-list-item-action>
                                                            <v-row>
                                                                <v-menu bottom origin="center center"
                                                                    transition="scale-transition">
                                                                    <template v-slot:activator="{ on, attrs }">
                                                                        <v-btn icon color="grey lighten-1"
                                                                            v-bind="attrs" v-on="on">
                                                                            <v-icon>menu</v-icon>
                                                                        </v-btn>
                                                                    </template>

                                                                    <v-list>



                                                                        <v-list-item>
                                                                            <v-btn icon>
                                                                                <v-icon color="grey lighten-1"
                                                                                    @click="eliminar(item)">delete</v-icon>
                                                                            </v-btn>
                                                                        </v-list-item>




                                                                    </v-list>
                                                                </v-menu>


                                                            </v-row>
                                                        </v-list-item-action>
                                                    </v-list-item>

                                                </template>
                                            </v-list>




                                        </v-row>
                                    </v-container>
                                </v-card-text>

                                <v-card-actions>
                                    <div class="flex-grow-1"></div>
                                    <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                                    <v-btn color="blue darken-1" text @click="guardar">Guardar</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>


                    </v-toolbar>
                </template>

                <template v-slot:item.action="{ item }">
                    <v-tooltip bottom>
                        <template #activator="{ on }">
                            <v-icon dense class="mr-2" @click="editItem(item)" v-on="on">edit</v-icon>
                        </template>
                        <span>Editar</span>
                    </v-tooltip>


                    <template v-if="item.expedienteestatus == 1">
                        <v-tooltip bottom>
                            <template #activator="{ on }">
                                <v-icon dense class="mr-2" @click="desactivar(item)" v-on="on">toggle_off</v-icon>
                            </template>
                            <span>Desactivar </span>
                        </v-tooltip>
                    </template>

                    <template v-if="item.expedienteestatus == 2">
                        <v-tooltip bottom>
                            <template #activator="{ on }">
                                <v-icon dense class="mr-2" @click="activar(item)" v-on="on">toggle_on</v-icon>
                            </template>
                            <span>Activar </span>
                        </v-tooltip>
                    </template>

                    <template>
                        <v-tooltip bottom>
                            <template #activator="{ on }">
                                <v-icon dense class="mr-2" @click="eliminar(item)" v-on="on">delete</v-icon>
                            </template>
                            <span>Eliminar </span>
                        </v-tooltip>
                    </template>


                </template>



                <template v-slot:no-data>
                    <v-btn color="primary" @click="listar">Reset</v-btn>
                </template>
                <template v-slot:item.expedienteestatus="{ item }">
                    <v-chip :color="getColor(item.expedienteestatus)" dark
                        v-if="item.expedienteestatus == 1">ACTIVO</v-chip>
                    <v-chip :color="getColor(item.expedienteestatus)" dark
                        v-if="item.expedienteestatus == 2">SUSPENDIDO</v-chip>
                </template>
            </v-data-table>
        </v-flex>
    </v-layout>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
    data() {
        return {
            // Variable de Imagen
            file: [],
            // Variable categoria
            expedientes: [],
            expedienteid: "",
            dialog: false,
            headers: [
                { text: "Operacion", value: "action", sortable: false },
                { text: "Nombre", value: "expedientenombre" },
                { text: "Estatus", value: "expedienteestatus", sortable: false },
            ],
            search: "",
            editedIndex: -1,
            //
            expedientenombre: "",
            usuarioid: "",

            valida: 0,
            validamensaje: [],
            adModal: 0,
            adAccion: 0,
            adNombre: "",
            adId: "",
            //
            dismissSecs: 5,
            dismissCountDown: 0,
            usuariocuenta: "",
            status: 0,
            rolid: "",
            rolselect: [],
            //
            carpetaid: "",
            carpetaselect: [],
            guardarsino: 0,

            data: [],
            items: [],
            selectedItem: 1,
            carpetanombre: ""


        };
    },
    // Crea una nueva categoria si es -1
    computed: {
        formTitle() {
            return this.editedIndex === -1 ? "Nueva expediente" : "Actualizando expediente";
        },
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
    },

    created() {
        this.listar();
        this.selectcarpeta();
    },

    //
    methods: {
        getHumanDate: function (date) {
            return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
        },

        getColor(socioestatus) {
            if (socioestatus == 1) return "#3F8103"; // Verde
            if (socioestatus == 2) return "#DA0707"; // Rojo
        },
        // metodo listar
        listar() {
            // Variable para cargar los datos del api
            let me = this;
            let header = { Authorization: this.$store.state.token };
            let configuracion = { headers: header };
            // Manda llamar al listado e catalogos
            axios
                .get("api/expedientes/listar", configuracion)
                .then(function (response) {
                    me.expedientes = response.data.expediente;
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.data.code == 400) {
                        me.$swal("La Sesión a Expirado");
                        me.$store.dispatch("salir");
                    }
                });
        },

        selectecarpetanombre() {
            this.carpetanombre = event.target.textContent;
        },

        // Select
        selectcarpeta() {
            let me = this;
            var listaArray = [];
            let header = { Authorization: this.$store.state.token };
            let configuracion = { headers: header };
            axios
                .get("api/carpetas/listardocumentos", configuracion)
                .then(function (response) {
                    listaArray = response.data.carpeta;
                    listaArray.map(function (x) {
                        me.carpetaselect.push({
                            text: x.carpetanombre,
                            value: x.carpetaid
                        });
                    });
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.data.code == 400) {
                        me.$swal("La Sesión a Expirado");
                        me.$store.dispatch("salir");
                    }
                });
        },

        agregar() {

            const newItem = { carpetaid: this.carpetaid, carpetanombre: this.carpetanombre };
            const exists = this.items.some(item =>
                item.carpetaid === newItem.carpetaid && item.carpetanombre === newItem.carpetanombre
            );

            if (exists) {
                this.$swal("Ese Documento ya Esta Agregado");
                return;
            } else {
                this.items.push(newItem);

            }
        },

        eliminar(idToDelete) {
            // Find the index of the item with the matching carpetaid
            const index = this.items.findIndex(item => item.carpetaid === idToDelete.carpetaid);

            // If the item is found (index is not -1), remove it
            if (index !== -1) {
                const deletedItem = this.items.splice(index, 1); // Remove 1 element at the found index
                console.log('Item deleted:', deletedItem);
            } else {
                console.warn('Item not found for deletion with ID:', idToDelete);
            }
        },

        // Actualiza la categotia
        editItem(item) {
            this.editedIndex = 1;
            this.dialog = true;
            this.expedientenombre = item.expedientenombre;
            this.expedienteid = item.expedienteid;
            this.carpetaid = item.carpetaid;
            this.usuarioid = item.usuarioid;
            this.guardarsino = 1;
        },

        close() {
            this.reportes = false;
            this.dialog = false;
            this.limpiar();
        },

        limpiar() {
            this.editedIndex = -1;
            this.expedientenombre = "";
            this.expedienteid = "";
            this.carpetaid = "";
            this.items=[];
            this.guardarsino = 0;
        },

        guardar() {

            if (this.expedientenombre == "") {
                this.$swal("No se a Especificado Nombrel Tarea");
                return;
            }

            if (this.items.length == 0) {
                this.$swal("No se hay Documentos Asignados a la Tarea");
                return;
            }

            let header = { Authorization: this.$store.state.token };
            let configuracion = { headers: header };
            let me = this;

            if (me.guardarsino == 0) {

                axios
                    .post(
                        "api/expedientes/crear",
                        {
                            expedientenombre: me.expedientenombre,
                            usuarioid: me.$store.state.usuario.usuarioid,
                            documentos:JSON.stringify(me.items)
                        },
                        configuracion
                    )
                    .then(function (response) {
                        me.limpiar();
                        me.listar();
                        me.TablaVisible = 0;
                        me.dialog = false;
                        me.$swal("Capturado con Exito");
                    })
                    .catch(function (error) {
                        console.log(error);
                        if (error.response.data.code == 400) {
                            me.$swal("La Sesión a Expirado");
                            me.$store.dispatch("salir");
                        }
                    });

            }




            // Editar
            if (me.guardarsino == 1) {
                axios
                    .put(
                        "api/expedientes/actualizar/" + me.expedienteid,
                        {
                            carpetaid: me.carpetaid,
                            expedientenombre: me.expedientenombre,
                            usuarioid: me.$store.state.usuario.usuarioid,
                        },
                        configuracion
                    )
                    .then(function (response) {
                        me.TablaVisible = 0;
                        me.limpiar();
                        me.listar();
                        me.dialog = false;
                        me.$swal("Banco Actualizado con Exito");
                    })
                    .catch(function (error) {
                        console.log(error);
                        if (error.response.data.code == 400) {
                            me.$swal("La Sesión a Expirado");
                            me.$store.dispatch("salir");
                        }
                    });
            }


        },

        desactivar(item) {
            let me = this;
            let header = { Authorization: this.$store.state.token };
            let configuracion = { headers: header }; // Actualiza
            // Actualiza
            me.$swal({
                icon: "warning",
                title: "Estas Seguro de Desactivar el Expediente",
                text:
                    "Banco: " +
                    item.banconombre,
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Desactivar",
            }).then((result) => {
                if (result.value) {
                    axios
                        .post("api/expedientes/desactivar",
                            {
                                expedienteid: item.expedienteid
                            },
                            configuracion)
                        .then(function (response) {
                            me.botonver = 1;
                            me.limpiar();
                            me.listar();
                            me.$swal("Desactivado", "Se a Desactivado con Exito", "success");
                            me.close();
                        })
                        .catch(function (error) {
                            if (error.status === 401) {
                                me.$swal("La Sesión a Expirado");
                                me.$store.dispatch("salir");
                            }
                        });
                }
            });
        },


        activar(item) {
            let me = this;
            let header = { Authorization: this.$store.state.token };
            let configuracion = { headers: header }; // Actualiza
            me.$swal({
                icon: "warning",
                title: "Estas Seguro de Activar el Expediente",
                text:
                    "Banco: " +
                    item.expedientenombre,
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Activar",
            }).then((result) => {
                if (result.value) {
                    axios
                        .post("api/expedientes/activar",
                            {
                                expedienteid: item.expedienteid
                            },
                            configuracion)
                        .then(function (response) {
                            me.botonver = 1;
                            me.limpiar();
                            me.listar();
                            me.$swal("Desactivado", "Se a Desactivado con Exito", "success");
                            me.close();
                        })
                        .catch(function (error) {
                            if (error.status === 401) {
                                me.$swal("La Sesión a Expirado");
                                me.$store.dispatch("salir");
                            }
                        });
                }
            });
        },





    },
};
</script>